import React, { useState } from "react";
import { recommendBooks } from "@/lib/api";
import Modal from "./Modal";

const PLANET_EMOJI = { sun: "☀️", earth: "🌍", ice: "❄️", jungle: "🌿", blackhole: "🕳️", moon: "🌙", mars: "🔴", nebula: "🌌" };

export default function BookRecommenderModal({ open, onClose }) {
  const [ageYears, setAgeYears] = useState(10);
  const [ageMonths, setAgeMonths] = useState(0);
  const [interests, setInterests] = useState("space, brains, animals");
  const [level, setLevel] = useState("average");
  const [books, setBooks] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchRecs = async () => {
    setLoading(true);
    try {
      const totalMonths = (Number(ageYears) || 0) * 12 + (Number(ageMonths) || 0);
      // Minimum 9 months (Sean started reading at 9 months!)
      const ageFloat = Math.max(totalMonths, 9) / 12;
      const res = await recommendBooks({ age: ageFloat, interests, reading_level: level });
      setBooks(res.books || []);
    }
    catch { setBooks([]); }
    finally { setLoading(false); }
  };

  return (
    <Modal open={open} onClose={onClose} title="📚 Sean's Book Lab" testId="book-rec-modal" wide tint="mint">
      <p className="text-[var(--ink-soft)] text-sm mb-1">Tell me about you — I'll find books that fuel your Neurocardio Loop.</p>
      <p className="text-[var(--ink-soft)] text-[0.7rem] font-mono mb-4">📖 For scientists from 9 months & up — even read-aloud babies welcome!</p>
      <div className="grid sm:grid-cols-4 gap-3 mb-4">
        <div>
          <label className="label-tag block mb-1.5">// years</label>
          <input type="number" value={ageYears} min={0} max={120} onChange={(e) => setAgeYears(e.target.value)} className="field field-mono" data-testid="book-age-years" />
        </div>
        <div>
          <label className="label-tag block mb-1.5">// months</label>
          <input type="number" value={ageMonths} min={0} max={11} onChange={(e) => setAgeMonths(e.target.value)} className="field field-mono" data-testid="book-age-months" />
        </div>
        <div>
          <label className="label-tag block mb-1.5">// reading level</label>
          <select value={level} onChange={(e) => setLevel(e.target.value)} className="field" data-testid="book-level">
            <option value="easy">Easy</option>
            <option value="average">Average</option>
            <option value="challenging">Challenging</option>
          </select>
        </div>
        <div>
          <label className="label-tag block mb-1.5">// interests</label>
          <input value={interests} onChange={(e) => setInterests(e.target.value)} placeholder="space, dinosaurs..." className="field" data-testid="book-interests" />
        </div>
      </div>
      <button onClick={fetchRecs} disabled={loading} className="btn btn-primary mb-4" data-testid="book-fetch">
        {loading ? "🔬 scanning..." : "🚀 Get Sean's Picks"}
      </button>

      <div className="grid sm:grid-cols-2 gap-3" data-testid="book-results">
        {books.map((b, i) => (
          <div key={i} className="card-flat tint-green">
            <div className="flex items-start justify-between mb-1 gap-2">
              <div className="font-display text-lg text-[var(--ink)] leading-tight">{b.title}</div>
              <span className="text-2xl shrink-0">{PLANET_EMOJI[b.genre_planet] || "📖"}</span>
            </div>
            <div className="label-tag text-[var(--mint)] mb-2">by {b.author}</div>
            <p className="text-[var(--ink)] text-sm leading-relaxed">{b.why_sean_loves_it}</p>
          </div>
        ))}
      </div>
    </Modal>
  );
}
